// Module
var code = `<media-preview media="\$ctrl.media"></media-preview>`;
// Exports
export default code;